import { Link } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import {
  replaceMainSiteLinkHostname,
  getModalityFromHostname,
} from "../../services/Utils";
import SurveyStatusPage from "./SurveyStatusPage";

const VITE_CHAT_HOST =
  import.meta.env.VITE_CHAT_HOST || "https://chat.988lifeline.org";
const VITE_SMS_NUMBER = import.meta.env.VITE_SMS_NUMBER || "988";

const InternalServerErrorPage = () => {
  const { t } = useTranslation("common");
  const isSms = getModalityFromHostname(window?.location?.hostname) === "sms";

  const body = isSms ? (
    <Trans
      t={t}
      i18nKey="internalServerError.smsBody"
      components={{
        returnLink: (
          <Link
            href={`sms:${VITE_SMS_NUMBER}`}
            sx={{ fontWeight: 700, textDecoration: "underline" }}
          />
        ),
      }}
    />
  ) : (
    t("internalServerError.message")
  );
  const buttonText = isSms
    ? t("internalServerError.smsButton")
    : t("internalServerError.button");
  const buttonHref = isSms
    ? `sms:${VITE_SMS_NUMBER}`
    : replaceMainSiteLinkHostname(t("chatHomeUrl"), VITE_CHAT_HOST);

  return (
    <SurveyStatusPage
      title={t("internalServerError.title")}
      body={body}
      buttonText={buttonText}
      buttonHref={buttonHref}
    />
  );
};

export default InternalServerErrorPage;
